import React from "react";
import { connect } from "react-redux";
import { Select, MenuItem } from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
  currentPortalSelector,
  availablePortalsSelector,
} from "../../../store/selectors/user.selectors";
import { push } from "connected-react-router";
import { SMCPaths } from "../../../conf/Routes";

const DomainSelector = ({ currentPortal, availablePortals, navigateTo }) => {
  const classes = useStyles();
  function changeDomain(e) {
    const domainToChangeTo = e.target.value;
    if (domainToChangeTo !== currentPortal) {
      navigateTo(SMCPaths.relogin, { domainName: domainToChangeTo });
    }
  }

  // If there is 1 or less portals to choose, don't show dropdown
  if (!availablePortals || availablePortals.length <= 1) {
    let portalName = currentPortal;
    if (availablePortals) {
      const foundPortal = availablePortals.find(
        (portal) => portal.toLowerCase() === currentPortal.toLowerCase()
      );
      if (foundPortal) {
        portalName = foundPortal;
      }
    }
    return <span className={classes.domainSelector}>{portalName}</span>;
  } else {
    return (
      <Select
        value={currentPortal ? currentPortal.toLowerCase() : currentPortal}
        onChange={changeDomain}
        sx={{
          "& .MuiOutlinedInput-notchedOutline": {
            border: '0 !important',
          },
          "& .MuiSelect-select": {
            height: "22px !important",
            border: "none",
            color: "#e8f1ff !important",
            width: "163px",
            textAlign: "right",
            fontSize: "14px",
            whiteSpace: "nowrap",

            padding: 0,
          },
          "& .MuiSelect-icon": {
            color: "#fff",
          },
        }}
        disableunderline="true"
        MenuProps={{
          classes: {
            paper: classes.domainSelectorMenu,
          },
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
        }}
      >
        {availablePortals &&
          availablePortals.map((domain) => (
            <MenuItem
              key={domain}
              classes={{ root: classes.domainSelectorMenuItem }}
              value={domain.toLowerCase()}
            >
              {domain}
            </MenuItem>
          ))}
      </Select>
    );
  }
};

const useStyles = makeStyles({
  domainSelector: {
    color: "#e8f1ff !important",
    width: "163px",
    textAlign: "right",
    fontSize: "14px",
    whiteSpace: "nowrap",
  },
  domainSelectorIcon: {
    color: "#e8f1ff",
  },
  domainSelectorMenu: {
    borderRadius: 0,
  },
  domainSelectorMenuItem: {
    minHeight: "38px",
    maxHeight: "38px",
    fontSize: "15px",
  },
});

const mapStateToProps = (state) => ({
  currentPortal: currentPortalSelector(state),
  availablePortals: availablePortalsSelector(state),
});

const mapDispatchToProps = {
  navigateTo: push,
};

export default connect(mapStateToProps, mapDispatchToProps)(DomainSelector);
